import { useEffect } from "react";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../hooks/useTypedSelector";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Route } from "./Route";
import { getPlanningRoutes } from "../../infrastructure/redux/thunks/route/getPlanningRoutesThunk";
import { getPlanningTrucks } from "../../infrastructure/redux/thunks/truck/getPlanningTrucksThunk";
import { createPlanningRoute } from "../../infrastructure/redux/thunks/route/createPlanningRouteThunk";
import { GenerateRoutesButton } from "./GenerateRoutesButton";

const portal = document.createElement("div");
document.body.appendChild(portal);

export const Routes = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation("common");

  const { routes, trucks } = useAppSelector((state) => state.planning);

  useEffect(() => {
    if (routes.length === 0) {
      void dispatch(getPlanningRoutes());
    }

    if (trucks.length === 0) {
      void dispatch(getPlanningTrucks());
    }
  }, []);

  return (
    <div className="d-flex flex-wrap align-items-start">
      {routes.map((route) => (
        <Route key={route.id} route={route} portal={portal} />
      ))}

      <div
        className={"truck-card me-3 mb-3 bg-transparent d-flex flex-column"}
        style={{ minHeight: 74 }}
      >
        <div className={"mb-2"}>
          <Button
            className="btn-sm d-block w-100"
            onClick={() => {
              void dispatch(
                createPlanningRoute({
                  delta: 0,
                  weight: 0,
                }),
              );
            }}
          >
            {t("Add route")}
          </Button>
        </div>
        <div>
          <GenerateRoutesButton />
        </div>
      </div>
    </div>
  );
};
